// extracted by mini-css-extract-plugin
module.exports = {"qixi_share":"qixiInviteSuccess_qixi_share__uj_qF","load_btn":"qixiInviteSuccess_load_btn__1c426","mask":"qixiInviteSuccess_mask__cejjG"};